<template>
  <material-card
    v-if="balance !== null && balance !== undefined"
    icon="check"
    :color="$vuetify.theme.themes.light.secondary"
    :title="$t('components.member_view.sick_payment_card.sick_payment_bank')"
  >
    <v-card-text>
      <div class="row no-gutters">
        <div class="col-12 col-md-4 col-lg-3 col-xl-2">
          {{ $t("components.member_view.sick_payment_card.current_hours_balance") }}
          <br />
          <span class="minfo">
            {{ (Math.floor(parseFloat(balance.Balance) * 100) / 100).toFixed(2) }}
          </span>
        </div>
        <div class="col-12 col-md-4 col-lg-3 col-xl-2">
          {{ $t("components.member_view.sick_payment_card.remaining_sick_days") }}
          <br />
          <span class="minfo">
            {{ (Math.floor(parseFloat(balance.RemainingSickDays) * 100) / 100).toFixed(2) }}
          </span>
        </div>
      </div>
      <v-expansion-panels style="margin-top:10px">
        <v-expansion-panel>
          <v-expansion-panel-header class="v-card__title">
            <div class="row no-gutters">
              <div class="col">
                <v-icon class="member-expansion-panel-header-icon">
                  schedule
                </v-icon>
                <span class="member-expansion-panel-header">
                  {{ $t("components.memberview.balance_history") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <member-balance-history-table
              :memberIdentityId="memberIdentityId"
              @reload="reloadTransactions"
              ref="table"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <v-expansion-panel>
          <v-expansion-panel-header class="v-card__title">
            <div class="row no-gutters">
              <div class="col">
                <v-icon class="member-expansion-panel-header-icon">
                  payments
                </v-icon>
                <span class="member-expansion-panel-header">
                  {{ $t("components.memberview.transactions") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <member-transactions-table
              ref="transactions"
              :memberIdentityId="memberIdentityId"
            />
          </v-expansion-panel-content>
        </v-expansion-panel> -->
      </v-expansion-panels>
    </v-card-text>
    <error-handler :error="error"/>
  </material-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler.vue";
import MemberBalanceHistoryTable from './SickPayment/MemberBalanceHistoryTable.vue';
import MemberTransactionsTable from "./SickPayment/MemberTransactionsTable.vue";

export default {
  components: {
    MemberTransactionsTable,
    MemberBalanceHistoryTable,
    ErrorHandler,
  },
  props: ["memberIdentityId", "balance"],
  data() {
    return {
      error: undefined,
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters("common", ["plans", "claimsPlan"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("auth", ["user"]),
  },
  async mounted() {
    
  },
  methods: {
    reloadTransactions() {
      this.$refs.transactions.reload();
    },
    reload() {
      if (this.$refs.table) {
        this.$refs.table.reload();
      }
    }
  },
};
</script>
